module.exports = __webpack_public_path__ + "img/header1.7961add9.png";